<template>
  <div class="navbar-margin">
    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top">
      <b-navbar-brand>
        <router-link to="/">
          <img src="@/assets/images/nuiteqLogo.svg" />
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle
        v-if="currentPage !== '/login' && $authenticated.value"
        target="nav-collapse"
      ></b-navbar-toggle>

      <b-collapse v-if="$authenticated.value" id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto navbar-search-wrapper">
          <b-button @click="updateLiveWiki" size="sm" class="nuiteq-button mr-2">Update Search Index</b-button>
        </b-navbar-nav>
      </b-collapse>
      <div class="navbar-search-wrapper ml-auto" v-if="currentPage !== '/' && currentPage !== '/search' && !$authenticated.value">
        <div class="navbar-form" role="search">
          <div class="input-group">
            <input type="text" v-on:keyup.13="search" v-model="searchQuery" class="form-control search-form-control shadow-none" placeholder="Search">
            <div class="input-group-btn">
              <button class="btn btn-default search-button" @click="search()"><font-awesome-icon :icon="['fas', 'search']" /></button>
            </div>
          </div>
        </div>
		  </div>
      <b-collapse v-if="currentPage !== '/login' && $authenticated.value" id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-button size="sm" class="nuiteq-button mr-2" @click="handleClickSignOut">Logout</b-button>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Navbar',
  data() {
    return {
      searchQuery: '',
      isInit: false,
      isSignIn: false,
      isLoggedIn: false
    };
  },
  computed: {
    currentPage() {
      return this.$route.path;
    }
  },
  methods: {
    search() {
      this.$router.push({
        path: '/search?query=' + this.searchQuery
      });
      this.searchQuery = ''
    },
    updateLiveWiki() {
      axios
        .post(process.env.VUE_APP_BASE_URL + '/update')
        .then(response => {
          console.log(response);
        })
        .catch(e => {
          console.error(e);
        });
    },
    handleClickSignOut() {
      this.$authenticated.value = false;
      localStorage.removeItem('token');
      this.$router.go();
      this.$gAuth
        .signOut()
        .then(() => {
          // On success do something
          this.isSignIn = this.$gAuth.isAuthorized;
        })
        .catch(error => {
          // On fail do something
          console.log(error);
        });
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-dark {
  background-color: rgb(72, 60, 104) !important;
}
.nuiteq-button {
  min-width: 90px;
  color: #454545;
  width: auto;
  border-color: #f0b67f;
  background-color: #f0b67f;
  border-radius: 0px;
}
.nuiteq-button:hover {
  color: #454545;
  background-color: #ef9743;
  border-color: #ef9743;
}
.nuiteq-search {
  border-radius: 0px;
}

.navbar-margin {
  margin-bottom: 56px
}

.navbar-search-wrapper {
  max-width: calc(100% - 180px);
}

.search-button {
  background-color: white;
  border-radius: 0px 4px 4px 0px;
}

.search-form-control {
  border-radius: 4px 0px 0px 4px;
}

.search-form-control:focus {
  outline: none;
  border-color: #ef9743;
  box-shadow: 0 0 3px #ef9743;
}
</style>
